export default "__VITE_ASSET__CK$ijIZK__"